class ContactForm extends Component {
    constructor(el) {
        super(el);
        this.checkRedirect();
        this.el.addEventListener('submit', () => this.handleSubmission());
    }

    checkRedirect() {
        if (sessionStorage.getItem('formSubmitted')) {
            window.location.hash = "homepage-contact-form-anchor";
            sessionStorage.removeItem('formSubmitted');
        }
    }

    handleSubmission() {
        sessionStorage.setItem('formSubmitted', 'true');
    }
}
